import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BsChevronDown } from 'react-icons/bs';
import { ADAARIARoles } from '../../../models/ADA';

import Checkmark from '../../../assets/images/graphics/icn_checkmark.png';

import './ExhibitMenu.scss';

const ExhibitMenu = ({title, links}) => {
  const [click, setClick] = useState(false);
  const [selected, setSelected] = useState(0);
  const menuOpened = useSelector(state => state.data.menuOpened);

  const BarClicked = () => {
    setClick(!click);
  };

  const LinkClicked = i => {
    setSelected(i);
    setClick(false);
  };

  const BackgroundClicked = () => {
    setClick(false);
  };

  return (
    <div className={`pbp-navbar exhibit-menu-container ${click ? 'opened' : 'closed'}`}>
      <div className="background" onClick={BackgroundClicked} />
      <div className="content">
        <div className="bar" onClick={BarClicked}>
        <div className="pbp-text" role="button" aria-expanded={click} aria-controls="pbpMenu" tabIndex="0">{title}</div>
          <BsChevronDown className={click ? 'chevron active' : 'chevron inactive'} />
        </div>
        {click &&
        <ul className="dropdown" id="pbpMenu">
          {links.map((item, index) => (
            <li key={index} className={selected === index ? 'dropdown-item selected' : 'dropdown-item'}>
              <img className="checkmark" src={Checkmark} alt="" />
              <Link
                className={item.bold ? 'dropdown-link bold' : 'dropdown-link'}
                to={item.link}
                onClick={() => LinkClicked(index)}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
        }
      </div>
    </div>
  );
};

export default ExhibitMenu;
